import { authFailureResponse, setSuccessHeaders } from 'api/inc-api.mock-utils';
import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { users } from './oauth.fixture';

export const tokenMock = fn =>
  rest.post(`${getEnv('REACT_APP_ADMIN_API_URL')}/oauth/token`, fn);

export const logoutMock = fn =>
  rest.get(`${getEnv('REACT_APP_ADMIN_API_URL')}/oauth/logout`, fn);

export const handlers = () => [
  tokenMock((req, res, ctx) => {
    const body = decodeURIComponent(req.body)
      .split('&')
      .reduce((result, param) => {
        const splitParam = param.split('=');
        result[splitParam[0]] = splitParam[1];
        return result;
      }, {});

    if (body.grant_type === 'password') {
      const user = users[body.username];
      if (!!user) {
        return res(setSuccessHeaders(), ctx.status(200), ctx.json(user));
      } else if (body.username === '500') {
        return res(
          ctx.status(500),
          ctx.set({
            'incentivio-code': 'ERROR',
            'incentivio-message': 'unexpected error',
          }),
        );
      } else {
        return res(
          ctx.status(401),
          ctx.json({
            error: 'invalid_grant',
            error_description: 'Bad credentials',
          }),
        );
      }
    } else {
      // refresh token
      if (body.refresh_token === 'invalid')
        return authFailureResponse(req, res, ctx);

      const user = Object.values(users).find(
        user => user.refresh_token === body.refresh_token,
      );

      if (!!user) {
        return res(
          setSuccessHeaders(),
          ctx.status(200),
          ctx.json({ ...user, access_token: 'valid' }),
        );
      } else {
        return res(
          ctx.status(400),
          ctx.json({
            error: 'invalid_grant',
            error_description: 'Bad credentials',
          }),
        );
      }
    }
  }),
  logoutMock((_req, res, _ctx) => {
    return res(setSuccessHeaders());
  }),
];
